export const SelectModal = [
  { id: 1, name: "Doado" },
  { id: 2, name: "Vendido" },
];

export const optionSelectFilter = [
  { name: "Nome do Produto", value: 1 },
  { name: "Nº Patrimônio", value: 2 },
  { name: "Nº Série", value: 3 },
  { name: "Responsável", value: 4 },
  { name: "Fabricante", value: 5 },
  { name: "Descrição", value: 6 },
];

export const optionStatusFilter = [
  { name: "Disponível", value: 1 },
  { name: "Alocado", value: 2 },
  { name: "Em Manutenção", value: 3 },
  { name: "Doado", value: 4 },
  { name: "Vendido", value: 5 },
];

export const caseFilter = ["nameProduct", "assetNumber", "serialNumber", "userName", "manufacturer", "description"];

export const THEADERMOCK = [
  { name: "Nome do Produto", value: "nameProduct" },
  { name: "Nº Patrimônio", value: "assetNumber" },
  { name: "Nº Série", value: "serialNumber" },
  { name: "Status", value: "status" },
  { name: "Responsável", value: "userName" },
  { name: "Termo", value: "manufacturer" },
  { name: "Valor", value: "purchasePrice" },
];
